import angular from 'angular';
import LicenseRenewalWidgetComponent from './lottery-representatives-widget-component';

export default angular
  .module('lottery-representatives-widget', [])
  .component('lotteryRepresentativesWidget', new LicenseRenewalWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/lottery-representatives/lottery-representatives-widget-module.js